import { Box, Skeleton } from "@mui/material";

const BAR_WIDTHS = [82, 60, 45, 30, 15];

export default function BrandStagesFunnelSkeleton() {
  return (
    <Box sx={{ display: "flex", flexDirection: "column", gap: "22px" }}>
      {BAR_WIDTHS.map((width) => (
        <Box key={width} sx={{ display: "grid", gridTemplateColumns: "150px 1fr", alignItems: "center" }}>
          <Skeleton variant="text" width={100} />
          <Skeleton variant="rounded" height={34} sx={{ width: `${width}%`, borderRadius: "5px" }} />
        </Box>
      ))}
    </Box>
  );
}
